import ModalDelete from 'components/modal/ModalDelete';
import useDeleteTrigger from '../queries/useDeleteTrigger';

const TriggerDeleteModal = ({
    triggerData,
    resetToMainTable,
    isOpen,
    onClose,
}) => {
    const { mutate: deleteTrigger, isLoading } = useDeleteTrigger(
        triggerData.id,
        resetToMainTable,
        onClose,
    );

    const handleDelete = () => {
        deleteTrigger();
    };

    return (
        <ModalDelete
            type="Trigger"
            name={triggerData.name}
            isOpen={isOpen}
            handleClose={onClose}
            handleSubmit={handleDelete}
            closeWalkthroughId=""
            deleteWalkthroughId=""
            isDisabled={false}
            isLoading={isLoading}>
            Are you sure you want to delete this trigger? This action cannot be
            undone.
        </ModalDelete>
    );
};

export default TriggerDeleteModal;
